import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ jobTypeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `JobType/GetSearched`,
      params: jobTypeParams,
    });
    const allJobType = data;
    yield put(Actions.setAll({ allJobType }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateJobType({ jobTypeData, actionName, jobTypeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `JobType`,
      data: jobTypeData,
    });
    yield put(Actions.fetchAll({ jobTypeParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.JOB_TYPE_CREATED : CONSTANT_VARIABLES.JOB_TYPE_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteJobType({ id, jobTypeParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `JobType/${id}`,
    });
    yield put(Actions.fetchAll({ jobTypeParams }));
    notification('success', CONSTANT_VARIABLES.JOB_TYPE_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ALL, fetchAll)]);
  yield all([takeLatest(ActionTypes.ADD_OR_UPDATE_JOB_TYPE, addorUpdateJobType)]);
  yield all([takeLatest(ActionTypes.DELETE_JOB_TYPE, deleteJobType)]);
}
